import { CSSProperties } from 'react';
import bgImage from './assets/bg.png';

export const layoutStyles: CSSProperties = {
  backgroundImage: `url(${bgImage})`,
  backgroundRepeat: 'no-repeat',
};

export const containerStyles: CSSProperties = {
  backgroundColor: '#f5f5f5',
  maxWidth: '600px',
  margin: 'auto',
  padding: '32px',
  border: 'none',
  textAlign: 'center',
};

export const headStyles: CSSProperties = {
  borderBottom: 0,
  padding: 0,
};

export const bodyStyles: CSSProperties = { padding: 0, marginTop: '32px' };

export const cardHeaderStyles: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0',
  fontFamily: 'Roboto',
  fontWeight: '500',
  lineHeight: '24px',
  letterSpacing: '0em',
};

export const PageTitleStyles: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '32px',
  fontSize: '20px',
};

export const titleStyles: CSSProperties = {
  color: '#1f1f1f',
  textAlign: 'left',
  marginBottom: 0,
  fontFamily: 'Roboto',
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '24px',
  letterSpacing: '0em',
  fontStyle: 'normal',
  overflowWrap: 'break-word',
  hyphens: 'manual',
  textOverflow: 'unset',
  whiteSpace: 'pre-wrap',
};

export const buttonStyle: CSSProperties = { borderRadius: '3px' };

export const buttonLoginStyle: CSSProperties = {
  borderRadius: '3px',
  color: '#1677ff',
};
